let host = '//vip-school.vip.com'
if (process.env.NODE_ENV !== 'production') {
  host = ''
}
const apis = {
  // 查询推荐详情
  queryRecommendationDetails: {
    url: host + '/recommend/queryRecommendationDetails'
  },
  // 查询用户信息
  queryUser: {
    url: host + '/user/queryUser'
  },
  // 查询公告概览数量
  queryNoticeOverviewCount: {
    url: host + '/notice/queryNoticeOverviewCount'
  },
  // 查询公告概览
  queryNoticeOverviews: {
    url: host + '/notice/queryNoticeOverviews'
  },
  // 查询公告详情
  queryNoticeDetail: {
    url: host + '/notice/queryNoticeDetail'
  },
  // 分页查询指定分类下的课程
  queryCourseOverviews: {
    url: host + '/course/queryCourseOverviews'
  },
  // 查询我的课程
  queryMyCourses: {
    url: host + '/course/queryMyCourses'
  },
  // 查询我的课程的数量
  queryMyCourseCount: {
    url: host + '/course/queryMyCourseCount'
  },
  // 学习课程章节
  studyChapter: {
    url: host + '/course/studyChapter'
  },
  // 查询课程详情
  queryCourseDetail: {
    url: host + '/course/queryCourseDetail'
  },
  // 查询指定分类下的课程数量
  queryCourseCount: {
    url: host + '/course/queryCourseCount'
  },
  // 查询章节
  queryChapter: {
    url: host + '/course/queryChapter'
  },
  // 我喜欢/不喜欢课程
  like: {
    url: host + '/course/like'
  },
  // 查询分类树形结构
  queryCategoryTree: {
    url: host + '/category/queryCategoryTree'
  },
  // 获取课程搜索补全提示
  getCompletionSuggester: {
    url: host + '/course/getCompletionSuggester'
  },
  // 查询热门搜索关键词
  getHotKeywords: {
    url: host + '/course/getHotKeywords'
  },
  // 搜索课程
  searchCourses: {
    url: host + '/course/searchCourses'
  },
  // 获取课程搜索补全提示
  searchEnabled: {
    url: host + '/course/searchEnabled'
  },
  // 查询搜索历史
  searchHistory: {
    url: host + '/course/searchHistory'
  },
  // 查询课程一级分类
  queryCoursePrimaryCategories: {
    url: host + '/course/queryCoursePrimaryCategories'
  },
  // 登出
  signout: {
    url: host + '/user/signout'
  },
  // 个人中心-在线考试课程列表
  queryMyExams: {
    url: host + '/exam/queryMyExams'
  },
  // 考试中心列表
  queryExams: {
    url: host + '/exam/queryExams'
  },
  // 查询课程挂载的考试
  queryByCourseId: {
    url: host + '/exam/queryByCourseId'
  }
}
export default apis
